import Cookies from 'js-cookie';
import { v4 } from 'uuid';
import moment from 'moment';

import { firebaseAuth, db, firestoreStorage } from '@/plugins/firebase';
import { iServiceProvider } from './service-provider.types';
import { iAuthService } from './auth/auth.types';
import { iUserService } from './user/user.types';
import AuthService from './auth/auth';
import UserService from './user/user.service';
import { iFirestoreAuthService, iFirestoreDatabase } from './firestore/firestore.types';
import FirestoreAuthService from './firestore/firestore-auth';
import { FirestoreDatabase } from './firestore/firestore-db';
import { iCookieService } from './cookie/cookie.types';
import { iI18nService } from './i18n/i18n.types';
import { CookieService } from './cookie/cookie.service';
import { I18nService } from './i18n/i18n.service';
import { iGameService } from './game/game.types';
import { GameService } from './game/game.service';
import { iUidService } from './uid/uid.types';
import { UidService } from './uid/uid.service';
import { iDateService } from './date/date.types';
import { DateService } from './date/date.service';
import { iReviewService } from './review/review.types';
import { ReviewService } from './review/review.service';
import { iProfileService } from './profile/profile.types';
import ProfileService from './profile/profile.service';
import { iFirestoreStorage } from './firestore-storage/firestore-storage.types';
import { FirestoreStorage } from './firestore-storage/firestore-storage';
import { iProfilePicService } from './profile-pic/profile-pic.types';
import ProfilePicService from './profile-pic/profile-pic.service';
import { iProfileCoverService } from './profile-cover/profile-cover.types';
import ProfileCoverService from './profile-cover/profile-cover.service';

class ServiceProvider implements iServiceProvider {
  auth: iAuthService;

  user: iUserService;

  game: iGameService;

  cookie: iCookieService;

  i18n: iI18nService;

  fireAuth: iFirestoreAuthService;

  fireDb: iFirestoreDatabase;

  firestoreStorage: iFirestoreStorage;

  uid: iUidService;

  date: iDateService;

  review: iReviewService;

  profile: iProfileService;

  profilePic: iProfilePicService;


  profileCover: iProfileCoverService;


  constructor() {
    this.fireDb = new FirestoreDatabase(db);
    this.fireAuth = new FirestoreAuthService(firebaseAuth);
    this.firestoreStorage = new FirestoreStorage(firestoreStorage.ref());
    this.user = new UserService(this.fireDb.user);
    this.profile = new ProfileService(this.fireDb.profile);
    this.auth = new AuthService(this.fireAuth, this.user);
    this.cookie = new CookieService(Cookies);
    this.i18n = new I18nService(this.cookie);
    this.game = new GameService(this.fireDb.game);
    this.uid = new UidService({ v4 });
    this.date = new DateService(moment);
    this.review = new ReviewService(
      this.fireDb.review,
      this.uid,
      this.date,
    );
    this.profilePic = new ProfilePicService(this.firestoreStorage.profilePic);
    this.profileCover = new ProfileCoverService(this.firestoreStorage.profileCover);
  }
}

export default new ServiceProvider();
